<template>
  <div class="main-container">
    <!-- 头部栏 -->
    <HomeHeader tabIndex="3" />
    <!-- 内容 -->
    <div class="container">
      <div class="title">团队建设</div>
      <p>集友科技创新（深圳）有限公司拥有一支朝气蓬勃、充满活力、富有创新及创造能力的队伍，团队成员来自于国内外知名高校，拥有丰富的金融业、大型科技公司从业经验。</p>
      <p>另外，公司积极吸收新生力量，不断壮大人才队伍，为公司高质量发展奠定坚实基础。</p>
      <img class="bottom-img" :src="contentBg" />
    </div>
    <!-- 底部栏 -->
    <HomeFooter />
  </div>
</template>

<script>
import HomeHeader from '@/components/HomeHeader.vue'
import HomeFooter from '@/components/HomeFooter.vue'
export default {
  name: 'team',
  components: { HomeHeader, HomeFooter },
  data () {
    return {
      contentBg: require('@/assets/images/body_bg.png')
    }
  }
}
</script>

<style scoped lang="less">
  .main-container {
    .container {
      position: relative;
      margin: auto;
      width: 800px;
      min-height: calc(100vh - 200px);
      padding-bottom: 300px;
      box-sizing: border-box;
    }
    .title {
      padding: 30px 0 10px;
      font-size: 32px;
      text-align: center;
    }
    p {
      font-size: 18px;
      text-indent: 2em;
      text-align: justify;
    }
    .team-img {
      margin-left: 25%;
      width: 50%;
    }
    .bottom-img {
      position: absolute;
      left: 0;
      bottom: 0;
      width: 100%;
    }
  }
</style>